import React, { useState } from 'react';
import { Tab, Nav } from 'react-bootstrap';

import { GroupsList } from './components/KindergartenGroups';

//import RequestsQueue from './components/Queue';
import RequestsQueueFull from './components/QueueFull';

 const groupsData = [
    {
      id: 1,
      index: 1,
      title: "2024-2025 Група «Квітки»",
      subtitle: "Старша група — від 5-ти до 6-ти років",
      type: "Загального розвитку (без спеціалізацій)",
      availability: {
        full: { current: 5, total: 20 },
        short: { current: 1, total: 4 },
        inclusive: { current: 1, total: 2 }
      },
      available: false,
      teachers: "Онищук Таіса Петрівна, Чуприна Анна Євгенівна",
      children: [
        {
          lastName: "Шевченко",
          firstName: "Тарас",
          middleName: "Григорович",
          birthDate: "15.10.2023",
          documentNumber: "ІІ-БК908367",
          enrollmentDate: "01.01.2025",
          placeType: "Повного дня",
          foodType: "Звичайний"
        }
        // ... другие дети
      ]
    }
    // ... другие группы
  ];


const KindergartenMainInfo = ({kindergartenData})=>{

    const [activeTab, setActiveTab] = useState('about');

    return (
            <Tab.Container 
                id="kindergarten-tabs" 
                activeKey={activeTab} 
                onSelect={(k) => setActiveTab(k)}
              >
                <Nav variant="tabs" className="kindergarten-tabs">
                  <Nav.Item>
                    <Nav.Link eventKey="about">Опис садочку</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="groups">Групи</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="documents">Заяви</Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="about">
                    <div className="kindergarten-description">
                      <p>{kindergartenData.description}</p>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="groups">
                    <div className="groups-content">
                      <GroupsList 
                        groups={ kindergartenData.groups} 
                        id={kindergartenData._id}
                        mode="view"
                      />
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="documents">
                    <div className="documents-content">
                      <RequestsQueueFull kg_id={kindergartenData._id} period={2025}/>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
    )
}

export default KindergartenMainInfo